import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BaseResourceService } from '../../shared/services/base-resource.service';
import { PublicLink } from './public-link.model';

@Injectable({
    providedIn: 'root'
})
export class PublicLinkService extends BaseResourceService<PublicLink> {

    private publicLinkSubject = new BehaviorSubject<PublicLink | null>(null);

    public publicLink$ = this.publicLinkSubject.asObservable();

    public isPublicLinkForm: boolean = false;

    constructor(protected injector: Injector) {

        super('public_links', injector, PublicLink.fromJson);
    }

    public setPublicLink(currentUser: PublicLink): void {
        this.publicLinkSubject.next(currentUser);
    }

    public getPublicLink(): PublicLink | null {
        return this.publicLinkSubject.value;
    }
}
